<template>
  <div class="container-fluid p-0">
    <PageTitle :title="pageTitle" :titleSave="$t('label.salvar')" :isAdd="false" v-on:onSave="save()" v-on:onCancel="cancel()" :nameEdit="nameEdit" :withOutExcluir="true"/>

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
          <div class="card flex-fill ">
            <div class="card-body box-dashboard p-3">
              <div class="align-self-center">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3 ">
                      <label for="estado" class="form-label">{{ $t('label.estado') }}</label>
                      <input class="form-control" type="text" v-model="form.state" :class="{ 'is-invalid': $v.form.state.$dirty && $v.form.state.$error }" disabled="disabled">
                      <div class="invalid-feedback">
                        {{ $t('message.requiredField') }}
                       </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3 ">
                      <label for="email_group" class="form-label">{{ $t('label.grupoDeEmails') }}</label>
                      <v-select multiple :appendToBody="true" :filterable="false" @search="getEmailGroup" :options="groupList" v-model="relStatesEmailGroupSelected" label="name" index="email_group_id"
                          :reduce="r => r.email_group_id" :clearable="false" class="wf-select vue-select">
                          <template v-slot:selected-option="option">
                            {{ `${option.name}` }}
                          </template>
                          <template v-slot:option="option">
                            {{ `${option.name}` }}
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                            </template>
                          </template>
                        </v-select>
                      <div class="invalid-feedback">
                        {{ $t('message.requiredField') }}
                       </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'EstadoForm',
  components: {
    PageTitle
  },
  data: function () {
    return {
      pageTitle: `${this.$t('label.estado')} > Adicionar`,
      nameEdit: '',
      groupList: [],
      relStatesEmailGroupSelected: [],
      action: this.$actionNew,
      form: {}
    }
  },
  validations: {
    form: {
      state: { required }
    }
  },
  methods: {
    getById: function (id) {
      this.$store.dispatch('showPreload')
      axios.get(`/VocStates/${id}`)
        .then(response => {
          this.form = response.data
          this.nameEdit = ` ${this.form.state}`
          this.getRelStatesEmailGroupSelected()
        })
    },
    getRelStatesEmailGroupSelected: function () {
      this.relStatesEmailGroupSelected = []
      this.form.relStatesEmailGroup.forEach(e => {
        if (!this.relStatesEmailGroupSelected.includes(e.email_group_id)) {
          this.relStatesEmailGroupSelected.push(Number(e.email_group_id))
        }
      })
      this.getEmailGroup()
    },
    getEmailGroup: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.name = search
        params.email_group_id_array = this.relStatesEmailGroupSelected.join(',')
        loading(true)
        axios.get('/SysEmailGroup/getallcombo', { params })
          .then(response => {
            this.groupList = response.data.items
            loading(false)
          })
      } else if (!search) {
        params.email_group_id_array = this.relStatesEmailGroupSelected.join(',')
        axios.get('/SysEmailGroup/getallcombo', { params })
          .then(response => {
            this.groupList = response.data.items
          })
      }
    },
    save: function () {
      this.$v.$touch()
      if (this.$v.form.$invalid) {
        return
      }
      this.form.relStatesEmailGroup = []
      this.relStatesEmailGroupSelected.forEach(el => {
        this.form.relStatesEmailGroup.push({ email_group_id: el, state_id: this.form.state_id })
      })
      if (this.action === this.$actionEdit) {
        axios.put('/VocStates', this.form)
          .then(() => {
            this.$toasted.global.saved()
            this.cancel()
          })
      } else {
        axios.post('/VocStates', this.form)
          .then(() => {
            this.$toasted.global.saved()
            this.cancel()
          })
      }
    },
    cancel: function () {
      this.$router.replace('/admin/estado')
    },
    excluir: function () {
      if (confirm(this.$t('message.confirmDel'))) {
        axios.delete(`/VocStates/${this.form.state_id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.cancel()
          })
      }
    }
  },
  created: function () {
    this.getEmailGroup()
    this.action =
      this.$route.params.id !== this.$actionNew
        ? this.$actionEdit
        : this.$actionNew

    if (this.action === this.$actionEdit) {
      this.pageTitle = `${this.$t('label.estado')} > Alterar`
      this.getById(this.$route.params.id)
    }
  }
}
</script>
